import React from 'react';
import core from '@gin-betting/core';

import type { Analytics } from 'services/analytics';
import Icon from '../Icon';

import backIcon from 'assets/svg/arrow-left.svg';
import './backButton.scss';

const {
    utils: { goBack },
} = core;

interface Props {
    analytics?: Analytics;
}

const BackButton: React.FC<Props> = ({ analytics }) => {
    return (
        <button
            data-action={analytics?.action}
            data-category={analytics?.category}
            onClick={goBack}
            styleName="back"
            className="__app-BackButton"
        >
            <Icon glyph={backIcon} styleName="icon" />
        </button>
    );
};

export default BackButton;
